import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const useSidebar = (): boolean =>
  useSelector((state: RootState) => state.sidebar.isOpen);
